import { NativeValidationService } from '../validation/native-validation-service';

export function initRecaptchaFormGuard(): void {
    const validationService = NativeValidationService.getInstance();

    document.querySelectorAll<HTMLFormElement>('form[data-submit-guard]').forEach((form) => {
        let submitted = false;

        const recaptchaBtn = form.querySelector<HTMLButtonElement>('.g-recaptcha[data-callback="onSubmit"]');

        form.addEventListener('submit', (e) => {
            // aspnet-client-validation calls preventDefault() if invalid — respect that
            if (e.defaultPrevented) return;
            if (submitted) { e.preventDefault(); return; }
            submitted = true;

            const submitBtn = form.querySelector<HTMLButtonElement>('button[type="submit"]');
            if (submitBtn) {
                if (submitBtn.dataset.loadingText) submitBtn.textContent = submitBtn.dataset.loadingText;
                submitBtn.disabled = true;
            }
        });

        if (recaptchaBtn) {
            (window as any).onSubmit = () => {
                if (submitted) return;
                if (!validationService.validate(form)) return;
                submitted = true;

                if (recaptchaBtn.dataset.loadingText) recaptchaBtn.textContent = recaptchaBtn.dataset.loadingText;
                recaptchaBtn.disabled = true;

                // reCAPTCHA re-enables the button after calling the callback; fight back
                new MutationObserver(() => {
                    if (!recaptchaBtn.disabled) recaptchaBtn.disabled = true;
                }).observe(recaptchaBtn, { attributes: true, attributeFilter: ['disabled'] });

                form.submit();
            };
        }
    });
}
